module.exports = __webpack_public_path__ + "img/0220809172749.7ffb0cb8.jpg";